// Org-scoped selections persisted by atomWithStorage survive window.location.reload()
// (reload doesn't clear storage, and the atoms re-hydrate from it on init). When the acting
// organisation changes, those selections point at the previous org's domains/ids, so we drop
// them and let each atom fall back to its empty default. The license-data bootstrap in
// queries.js (useFetchLicenseDataAndSetStoreValues) then auto-selects the new org's first
// domain for the self-healing ones (audit entry / Assist domain).
//
// We intentionally keep table filters/sorts (the logout whitelist in
// clearStorageWithExeptions.js keeps them too), all UI preferences, the auth/session keys,
// and the X-Guest-Organisation selection itself.
const localStorageKeys = [
  'lastAuditEntryId',
  'selectedAssistDomain',
  'transSelectedDomain',
  'sharedConfiguratorDomain',
  'chats_v1',
  'activeChatIndex_v1',
];

const sessionStorageKeys = ['currentAuditEntryId'];

// Guided-test edit mode is stored per test under a key prefix.
const sessionStoragePrefixes = ['EA_guidedTesting_isEditMode_'];

function resetGuestOrgSelections() {
  for (const key of localStorageKeys) {
    localStorage.removeItem(key);
  }

  for (const key of sessionStorageKeys) {
    sessionStorage.removeItem(key);
  }

  for (const key of Object.keys(sessionStorage)) {
    if (sessionStoragePrefixes.some((prefix) => key.startsWith(prefix))) {
      sessionStorage.removeItem(key);
    }
  }
}

export default resetGuestOrgSelections;
